import { Carriers } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import {
  FulfillmentOrderAddressSchema,
  type IFulfillmentOrderAddress,
} from "@redotech/redo-fulfillment-customs-common/fulfillment-order-address";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getOriginAddresses = {
  name: "getOriginAddresses" as const,
  input: z.object({ carrier: createEnum(Carriers) }),
  output: z.object({
    addresses: z.array(
      FulfillmentOrderAddressSchema as IFulfillmentOrderAddress,
    ),
  }),
};
